/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/image/image-cache.directive';
import * as import2 from '../../ui-elements/image/cached-image.service';
import * as import3 from '@angular/common';
import * as import4 from 'ng2-translate/src/translate.pipe';
import * as import5 from 'ng2-translate/src/translate.service';
import * as import6 from '../../buttons/button/button.component.ngfactory';
import * as import7 from '../../buttons/button/button.component';
import * as import8 from '../../orchestration/session.model';
import * as import9 from '../../orchestration/responsive.service';
import * as import10 from '../../order/order-item/dietary-panel/dietary-panel.component.ngfactory';
import * as import11 from '../../order/order-item/dietary-panel/dietary-panel.component';
import * as import12 from '../../html-utils/html.pipe';
import * as import13 from '@angular/platform-browser';
import * as import14 from '../../string-utils/currency.pipe';
import * as import15 from './menu-item-panel.component';
import * as import16 from '../menu.model';
import * as import17 from '../../promo/promo.model';
import * as import18 from '../../order/order.model';
const styles_MenuItemPanelComponent:any[] = ([] as any[]);
export const RenderType_MenuItemPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MenuItemPanelComponent,
  data: {}
}
);
function View_MenuItemPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'menu-item-image-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import1.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import2.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.image;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_MenuItemPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'menu-item-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'unavailable',
      'empty'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'menu-item-image';
    const currVal_1:any = ck(v,2,0,(co.canShowDetails && co.showUnavailable),!co.image);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = co.image;
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_MenuItemPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-item-details-header-main-promos-promo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.featureTag;
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'menu-item-details-header-main-promos-promo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpod(['amount']),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform('woa.button.order.bonusPoints',ck(v,2,0,co.menuItem.sellable.bonusPoints)));
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'menu-item-details-header-main-promos'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.featureTag;
    ck(v,3,0,currVal_0);
    const currVal_1:any = ((co.menuItem == null)? (null as any): co.menuItem.sellable.bonusPoints);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_MenuItemPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-item-details-header-main-title-sizes-size'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'menu-item-details-header-main-title-sizes'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_7)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_MenuItemPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'menu-item-details-header-stock'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.label.order.outOfStock'));
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'menu-item-details-header-stock'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.label.order.atLimit'));
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'menu-item-details-header-action'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.selectItem($event)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_ButtonComponent_0,import6.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import7.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import9.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.order.addToOrder';
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_MenuItemPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-item-details-body-category'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectCategory($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.menuModel.getCategoryPath(co.category);
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'menu-item-details-footer-pricing-price-guest'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>(<any>v.parent).parent),1),((co.menuItem == null)? (null as any): co.menuItem.sellable.defaultGuestPrice)));
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-item-details-footer-pricing-size'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_MenuItemPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'menu-item-details-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'menu-item-details-footer-pricing'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'menu-item-details-footer-pricing-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'menu-item-details-footer-pricing-price-actual'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['discounted']),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_14)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-dietary-panel',[[
        'class',
        'menu-item-details-footer-dietary'
      ]
    ],(null as any),(null as any),(null as any),import10.View_DietaryPanelComponent_0,import10.RenderType_DietaryPanelComponent)),
      import0.ɵdid(49152,(null as any),0,import11.DietaryPanelComponent,([] as any[]),{sellable: [
        0,
        'sellable'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.menuItem == null)? (null as any): co.menuItem.sellable.guestPrice);
    ck(v,7,0,currVal_0);
    const currVal_1:any = 'menu-item-details-footer-pricing-price-actual';
    const currVal_2:any = ck(v,11,0,co.menuItem.sellable.guestPrice);
    ck(v,10,0,currVal_1,currVal_2);
    const currVal_4:any = co.menuModel.getItemSizeQualifier(co.menuItem);
    ck(v,17,0,currVal_4);
    const currVal_5:any = ((co.menuItem == null)? (null as any): co.menuItem.sellable);
    ck(v,21,0,currVal_5);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = import0.ɵunv(v,12,0,ck(v,13,0,import0.ɵnov((<any>v.parent),1),((co.menuItem == null)? (null as any): co.menuItem.sellable.defaultPrice)));
    ck(v,12,0,currVal_3);
  });
}
export function View_MenuItemPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    import0.ɵpid(0,import12.HtmlPipe,[import13.DomSanitizer]),
    import0.ɵpid(0,import14.CurrencyPipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),44,'div',[[
        'class',
        'menu-item-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-image']),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),27,'div',[[
        'class',
        'menu-item-details-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-order-action']),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'menu-item-details-header-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'menu-item-details-header-main-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-item-details-header-main-title-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'menu-item-details-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-item-details-body-description'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemPanelComponent_12)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import15.MenuItemPanelComponent = v.component;
    const currVal_0:any = co.menuModel.showItemImages;
    ck(v,3,0,currVal_0);
    const currVal_1:any = 'menu-item-details';
    const currVal_2:any = ck(v,7,0,co.menuModel.showItemImages);
    ck(v,6,0,currVal_1,currVal_2);
    const currVal_3:any = 'menu-item-details-header';
    const currVal_4:any = ck(v,11,0,co.showOrderAction);
    ck(v,10,0,currVal_3,currVal_4);
    const currVal_5:any = (co.canShowDetails && (co.featureTag || ((co.menuItem == null)? (null as any): co.menuItem.sellable.bonusPoints)));
    ck(v,16,0,currVal_5);
    const currVal_7:any = (co.canShowDetails && co.menuModel.getItemSizeSummary(co.menuItem));
    ck(v,24,0,currVal_7);
    const currVal_8:any = (co.canShowDetails && co.showOutOfStock);
    ck(v,29,0,currVal_8);
    const currVal_9:any = (co.canShowDetails && co.showAtLimit);
    ck(v,32,0,currVal_9);
    const currVal_10:any = (co.canShowDetails && co.showOrderAction);
    ck(v,35,0,currVal_10);
    const currVal_11:any = (co.category && co.showCategoryPath);
    ck(v,41,0,currVal_11);
    const currVal_13:any = co.canShowDetails;
    ck(v,48,0,currVal_13);
  },(ck,v) => {
    var co:import15.MenuItemPanelComponent = v.component;
    const currVal_6:any = co.menuModel.getItemName(co.menuItem);
    ck(v,21,0,currVal_6);
    const currVal_12:any = import0.ɵunv(v,43,0,ck(v,44,0,import0.ɵnov(v,0),co.menuModel.getItemDescription(co.menuItem)));
    ck(v,43,0,currVal_12);
  });
}
function View_MenuItemPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-panel',([] as any[]),[[
        2,
        'tile',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).selectItem($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_MenuItemPanelComponent_0,RenderType_MenuItemPanelComponent)),
    import0.ɵdid(704512,(null as any),0,import15.MenuItemPanelComponent,[
      import16.MenuModel,
      import17.PromoModel,
      import0.ChangeDetectorRef,
      import18.OrderModel
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).tile;
    ck(v,0,0,currVal_0);
  });
}
export const MenuItemPanelComponentNgFactory:import0.ComponentFactory<import15.MenuItemPanelComponent> = import0.ɵccf('woa-menu-item-panel',import15.MenuItemPanelComponent,View_MenuItemPanelComponent_Host_0,{
  category: 'category',
  menuItem: 'menuItem',
  useOrderAction: 'useOrderAction',
  tile: 'tile',
  showCategoryPath: 'showCategoryPath',
  showDetails: 'showDetails'
}
,{onSelectItem: 'onSelectItem'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/menu/menu-item-panel/menu-item-panel.component.ngfactory.ts